import secureApi from "../../utils/secureApi";

export interface TournamentFeatureToggle {
  name: string;
  label: string;
  enabled: boolean;
}

const basePath = (seasonId: string) =>
  `/api/v2/tournaments/multi-sports/manage/tournament-season/${seasonId}/feature-toggles`;

const unwrap = (response: any): TournamentFeatureToggle[] => {
  const data = response?.data ?? response;
  return Array.isArray(data) ? data : [];
};

export async function listTournamentFeatureToggles(
  seasonId: string
): Promise<TournamentFeatureToggle[]> {
  return unwrap(await secureApi.get(basePath(seasonId)));
}

export async function setTournamentFeatureToggle(
  seasonId: string,
  featureName: string,
  enabled: boolean
): Promise<TournamentFeatureToggle[]> {
  return unwrap(
    await secureApi.post(`${basePath(seasonId)}/${encodeURIComponent(featureName)}`, {
      enabled,
    })
  );
}
